import { lazy } from 'react';

export const CreateEventPage = lazy(() => import('./controller.js'));
